// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3Gm9C","name":"ConsentHeader_name__3FNB9","birthday":"ConsentHeader_birthday__3SCqN","skeleton":"ConsentHeader_skeleton__h8Jxb"};